import React from 'react';

import {
  type InfiniteListFetcherProps,
  InfiniteListFetcherRTK,
} from 'app/general/datafetchers/InfiniteListFetcherRTK';
import {convertLocationParamsToFetchParams} from 'app/policies/api';
import {getBasicTeamsFromRelated} from 'app/teams/utils';

import {useLazyPolicies} from './api';

import type {PoliciesFetchParamsType} from './types';
import type {
  DetailPolicySerializedType,
  RawDetailPolicySerializedType,
  RelatedTeamsSerializedType,
} from 'sweet-types';

export const PoliciesInfiniteListFetcherRTK = (
  props: InfiniteListFetcherProps<DetailPolicySerializedType>
) => (
  <InfiniteListFetcherRTK<DetailPolicySerializedType, PoliciesFetchParamsType>
    {...props}
    useLazyDataHook={useLazyPolicies}
    paramsConverter={convertLocationParamsToFetchParams}
  />
);

export function standardizeRawPolicy(
  doc: RawDetailPolicySerializedType,
  related: RelatedTeamsSerializedType
): DetailPolicySerializedType {
  return {
    ...doc,
    team_names: getBasicTeamsFromRelated(doc, related),
  };
}
